export default "__VITE_ASSET__cE$jTmpM__"